<template>
  <b-input-group size="sm" v-if="dateColumnInfo.visible()">
    <template v-slot:prepend v-if="labelVisible">
      <b-input-group-text class="group-text"
        >{{ dateColumnInfo.label }}
        <span v-if="dateRules == INPUT_TYPE_CHECK.REQUIRED">*</span>
      </b-input-group-text>
    </template>
    <BaseDateInput
      v-model="_dateValue"
      :columnInfo="dateColumnInfo"
      :error-visible="errorVisible"
      :rules="dateRules"
      :state="state"
      :locale="locale"
    />
    <BaseTimeInput
      v-if="timeFromColumnInfo != null"
      v-model="_timeFromValue"
      :columnInfo="timeFromColumnInfo"
      :error-visible="errorVisible"
      :rules="timeFromRules"
      :rangeTarget="rangeTarget"
      :state="state"
      :locale="locale"
    />
    {{ '～' }}
    <BaseTimeInput
      v-if="timeToColumnInfo != null"
      v-model="_timeToValue"
      :columnInfo="timeToColumnInfo"
      :error-visible="errorVisible"
      :rules="timeToRules"
      :state="state"
      :locale="locale"
    />
  </b-input-group>
</template>

<script>
export default {
  name: 'BaseDateAndTimeFromTo',
  inheritAttrs: false,
  props: {
    labelVisible: {
      type: Boolean,
      default: false,
    },

    dateValue: {
      type: [String, Number],
      default: '',
    },

    timeFromValue: {
      type: String,
      default: '',
    },

    timeToValue: {
      type: String,
      default: '',
    },

    locale: {
      type: String,
      default: 'ja',
    },

    /**
     * 定義情報.
     * @type {Object}
     * @requires
     */
    dateColumnInfo: {
      type: Object,
      required: true,
    },

    timeFromColumnInfo: {
      type: Object,
      default: null,
    },

    timeToColumnInfo: {
      type: Object,
      default: null,
    },

    /**
     * バリデーションチェックの状態を表示するか.
     * @type {Boolean}
     */
    state: {
      type: Boolean,
      default: false,
    },

    /**
     * エラーメッセージを表示するか.
     * @type {Boolean}
     */
    errorVisible: {
      type: Boolean,
      default: true,
    },

    /**
     * 入力検証ルール.
     * @type {String}
     */
    dateRules: {
      type: Array,
      default: () => [],
    },
    /**
     * 入力検証ルール.
     * @type {String}
     */
    timeFromRules: {
      type: Array,
      default: () => [],
    },
    /**
     * 入力検証ルール.
     * @type {String}
     */
    timeToRules: {
      type: Array,
      default: () => [],
    },

    rangeTarget: {
      type: String,
      default: null,
    },
  },
  computed: {
    _dateValue: {
      get() {
        return this.dateValue
      },
      set(v) {
        if (this.dateValue !== v) this.$emit('update:dateValue', v)
      },
    },
    _timeFromValue: {
      get() {
        return this.timeFromValue
      },
      set(v) {
        if (this.timeFromValue !== v) this.$emit('update:timeFromValue', v)
      },
    },
    _timeToValue: {
      get() {
        return this.timeToValue
      },
      set(v) {
        if (this.timeToValue !== v) this.$emit('update:timeToValue', v)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-border {
  border-left: 1px white solid;
}
</style>
